import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClickedElementService {
  public documentClickedTarget: Subject<EventTarget> = new Subject<EventTarget>();
}
